import React from 'react'
import WarningIcon from '@Images/warning-icon-auth.svg'

interface ValidationMessageProps {
  readonly message: string
}

const ValidationMessage: React.FC<ValidationMessageProps> = (props) => {
  const { message } = props

  if (!message) {
    return null
  }

  return (
    <div className="AuthInput__error">
      <span className="AuthInput__error-icon">
        <WarningIcon />
      </span>
      <span>{message}</span>
    </div>
  )
}

export default ValidationMessage
